"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

document.addEventListener('DOMContentLoaded', function () {
  var hubspotFormContact, hubspotMeet, customFormMeet, submitButton; // Poll Hubspot form to see when it's loaded

  function pollHubspotForm() {
    if (document.getElementById('hsForm_47f0a727-75fe-4353-b6c7-a726dbf8b33a')) {
      hubspotFormContact = document.getElementById('hsForm_47f0a727-75fe-4353-b6c7-a726dbf8b33a');
      populateCustomFormFields();
    } else {
      setTimeout(pollHubspotForm, 15);
    }
  }

  pollHubspotForm();

  function addSelectorElement(label, value, field, selected) {
    var customOption = document.createElement('span');
    customOption.textContent = label;
    customOption.dataset.value = value;
    selected ? customOption.classList.add('custom-option', 'selected') : customOption.classList.add('custom-option');
    field.querySelector('.custom-options').append(customOption);
  } // Populate custom select fields using Hubspot form


  function populateCustomFormFields() {
    hubspotMeet = document.getElementById('how_should_we_meet-47f0a727-75fe-4353-b6c7-a726dbf8b33a');
    customFormMeet = document.getElementById('meet');
    Array.from(hubspotMeet.options).forEach(function (option, index) {
      if (index > 0) {
        // Ignore first hubspot select option
        addSelectorElement(option.innerHTML, option.value, customFormMeet, false);
      } else {
        document.querySelector('.custom-select__meet span').textContent = "-- Make your choice --";
        document.querySelector('.custom-select__meet span').dataset.value = ""; //   addSelectorElement("????", "", customFormMeet, true);
      }
    }); // let roleClone = customFormRole.cloneNode(true);
    // roleClone.id = '';
    //  document.getElementById('grenade-role').appendChild(roleClone);

    initialiseSelectHandlers();
  } // Handle custom select boxes


  function initialiseSelectHandlers() {
    var selectWrappers = document.querySelectorAll('.custom-select-wrapper');
    var selectWrapper;
    var submitButton = document.querySelector('#submitBtn');
    var firstnameRow = document.querySelector('#firstnameRow');
    var lastnameRow = document.querySelector('#lastnameRow');
    var emailRow = document.querySelector('#emailRow');
    var phoneRow = document.querySelector('#phoneRow');
    var messageRow = document.querySelector('#messageRow');
    var submitBtn = document.querySelector('#submitBtn'); //let messageField = document.querySelector('#message')

    var _iterator = _createForOfIteratorHelper(selectWrappers),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        selectWrapper = _step.value;
        selectWrapper.addEventListener('click', function () {
          this.querySelector('.custom-select').classList.toggle('open');
        });
      } // Select Options

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var _iterator2 = _createForOfIteratorHelper(document.querySelectorAll('.custom-option')),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var option = _step2.value;
        option.addEventListener('click', function () {
          if (!this.classList.contains('selected')) {
            var selectedItems = this.parentNode.querySelectorAll('.custom-option');

            var _iterator4 = _createForOfIteratorHelper(selectedItems),
                _step4;

            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var selectedItem = _step4.value;

                if (selectedItem.classList.contains('selected')) {
                  selectedItem.classList.remove('selected');
                }
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }

            this.classList.add('selected');
            var optionValue = this.dataset.value;
            this.closest('.custom-select').querySelector('.custom-select__trigger span').textContent = this.textContent;
            this.closest('.custom-select').querySelector('.custom-select__trigger span').dataset.value = optionValue;
            messageRow.style.display = "none";
            phoneRow.style.display = "none";
            submitBtn.style.display = "block"; // messageField.value = "";

            switch (optionValue) {
              case 'set_up_meeting_at_mf':
                break;

              case 'meet_beer_during_mf':
                phoneRow.style.display = "block";
                break;

              case 'set_up_meeting_outside_mf':
                firstnameRow.style.display = "none";
                lastnameRow.style.display = "none";
                emailRow.style.display = "none";
                submitBtn.style.display = "none";
                messageRow.style.display = "block";
                break;

              case 'no_meeting':
                break;
            }

            showStage('.contact-form__stage--2');
          }
        });
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    var selects = document.querySelectorAll('.custom-select');
    window.addEventListener('click', function (e) {
      var _iterator3 = _createForOfIteratorHelper(selects),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var select = _step3.value;

          if (!select.contains(e.target)) {
            select.classList.remove('open');
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    });
  } // Show a new stage of the form


  var showStage = function showStage(element) {
    var stage = document.querySelector(element);
    TweenMax.fromTo(stage, 0.75, {
      y: 40,
      opacity: 0
    }, {
      y: 0,
      opacity: 1,
      display: 'block',
      ease: Power1.easeInOut
    });
  };

  var hideStage = function hideStage(hide, show) {
    var _iterator5 = _createForOfIteratorHelper(hide),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var hide__stage = _step5.value;
        var stage = document.querySelector(hide__stage);
        TweenMax.set(hide__stage, {
          display: 'block'
        });
        TweenMax.fromTo(stage, 0.75, {
          y: 0
        }, {
          y: -90,
          opacity: 0,
          display: 'none',
          ease: Power1.easeInOut,
          onComplete: showStage,
          onCompleteParams: [show]
        });
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  };

  function getOptionSelected(selectID) {
    var select = document.querySelector(selectID);
    var selectedItems = select.querySelectorAll('.custom-option');

    var _iterator6 = _createForOfIteratorHelper(selectedItems),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var selectedItem = _step6.value;

        if (selectedItem.classList.contains('selected')) {
          return selectedItem.dataset.value;
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }

    return null;
  }

  function getMessageOption(optionValue) {
    var message;

    switch (optionValue) {
      case 'set_up_meeting_at_mf':
        message = "To guarantee we meet you must now select <span class='txt--blue'>'Would like to meet'</span> next to Carswell Gould on the 2021 Marketing Forum web page you have been sent by Richmond Events.<br /> See you there.";
        break;

      case 'meet_beer_during_mf':
        message = "Good choice! We’ll be in the bar at the end of the day and we look forward to meeting you there : )";
        break;

      case 'set_up_meeting_outside_mf':
        message = "Great, we'll be in touch with you shortly.";
        break;

      case 'no_meeting':
        message = "Ouch! Well that hurts but okay. If you change your mind you can get back in contact with us by emailing <a href='mailto:info@carswellgould.co.uk'><span class='txt--blue'>info@carswellgould.co.uk</span></a>";
        break;

      default:
        message = "Thanks";
    }

    return message;
  } // Submit contact form


  function handleSubmitContact(event) {
    event.preventDefault();
    var firstName = document.getElementById('first-name').value;
    var lastName = document.getElementById('last-name').value;
    var email = document.getElementById('email').value;
    var phone = document.getElementById('phone').value;
    var meet = customFormMeet.querySelector('.custom-select__meet span').dataset.value;
    var cg_meet_poc = document.getElementById('cg_meet_poc').value; // let message =  document.getElementById('message').value;

    var step3Title = document.querySelector('#step3Title');
    document.getElementById('firstname-47f0a727-75fe-4353-b6c7-a726dbf8b33a').value = firstName;
    document.getElementById('lastname-47f0a727-75fe-4353-b6c7-a726dbf8b33a').value = lastName;
    document.getElementById('email-47f0a727-75fe-4353-b6c7-a726dbf8b33a').value = email; // document.getElementById('message-47f0a727-75fe-4353-b6c7-a726dbf8b33a').value = message;

    document.getElementById('phone-47f0a727-75fe-4353-b6c7-a726dbf8b33a').value = phone;
    document.querySelector("[name=cg_meet_poc]").value = cg_meet_poc;
    hubspotMeet.value = meet;
    step3Title.innerHTML = getMessageOption(getOptionSelected('#meet'));
    hubspotFormContact.submit();
    ga('send', 'event', 'Forms', 'Submission', 'Submission from Meet CG', 1);
    hideStage(['.contact-form__stage--1', '.contact-form__stage--2'], '.contact-form__stage--3');
  }

  var contactForm = document.getElementById('contact-form');
  contactForm.addEventListener('submit', handleSubmitContact); // // Everything else
  // document.querySelectorAll('.form_area').forEach(item => {
  //     tween = TweenMax.fromTo(item, 1.5, {y: 40, opacity: 0}, {y: 0, opacity: 1, ease: Power1.easeInOut})
  //
  //     let scene = new ScrollMagic.Scene({
  //         triggerElement: item,
  //         triggerHook: 0.85
  //     })
  //
  //         .setTween(tween)
  //         .addTo(controller);
  // });
});